import React from 'react';
import { Check } from 'lucide-react';

/**
 * Stepper d'onboarding 3 étapes — style dossier bancaire.
 * Étapes : 1) Mot de passe défini, 2) Profil, 3) Bienvenue
 * Indique l'étape courante via la prop `step` (1, 2, ou 3).
 */
const OnboardingStepper = ({ step = 1 }) => {
  const steps = [
    { n: 1, label: 'Mot de passe' },
    { n: 2, label: 'Profil' },
    { n: 3, label: 'Bienvenue' },
  ];

  return (
    <div className="onboarding-stepper" data-testid="onboarding-stepper" role="navigation" aria-label="Étapes d'inscription">
      {steps.map((s, idx) => {
        const isDone = s.n < step;
        const isCurrent = s.n === step;
        return (
          <React.Fragment key={s.n}>
            <div
              className={`stepper-item ${isDone ? 'is-done' : ''} ${isCurrent ? 'is-current' : ''}`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <div className="stepper-dot">
                {isDone ? <Check className="w-3 h-3" strokeWidth={3} /> : <span>{s.n}</span>}
              </div>
              <span className="stepper-label">{s.label}</span>
            </div>
            {idx < steps.length - 1 && (
              <div className={`stepper-line ${isDone ? 'is-done' : ''}`} aria-hidden="true" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default OnboardingStepper;
